<template>
  <div @click.stop="$emit('switch')">
    <input :checked="active" v-model="active" type="checkbox" />
    <label
      :class="[
        !active && !block
          ? 'bg-ontick-carbon-400 bg-opacity-50'
          : block && !active
          ? 'bg-ontick-red-600'
          : 'bg-ontick-blue-600',
        size === 'md' ? 'check-trail' : 'check-trail-sm',
      ]"
    >
      <span
        :content="
          !active && !block
            ? 'Investimento parado'
            : block && !active
            ? 'Erro, verifique o parâmetro abaixo'
            : 'Investimento em execução'
        "
        v-tippy="{ arrow: true, theme: block && !active ? 'red' : 'green' }"
        class="flex justify-center bg-white"
        :class="[
          active ? 'check-handler-active' : '',
          size === 'md' ? 'check-handler' : 'check-handler-sm',
        ]"
      >
        <span v-show="active" class="ml-1" v-html="$icons.play_2"></span>
      </span>
    </label>
  </div>
</template>
<script>
export default {
  data() {
    return {
      checked: false,
    };
  },
  props: {
    active: {
      type: Boolean,
    },
    block: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: "md",
      validator: (val) => {
        return ["sm", "md"].includes(val);
      },
    },
  },
  methods: {
    activeToogle() {
      this.checked = !this.checked;
    },
  },
};
</script>
<style lang="scss" scoped>
input[type="checkbox"] {
  position: absolute;
  opacity: 0;
  z-index: -1;
}
.check-trail {
  display: flex;
  align-items: center;
  width: 3.2em;
  height: 1.8em;
  border-radius: 2.5em;
  transition: all 0.5s ease;
  cursor: pointer;
  &-sm {
    display: flex;
    align-items: center;
    width: 1.875rem;
    height: 1rem;
    border-radius: 2.5rem;
    transition: all 0.5s ease;
    cursor: pointer;
  }
  /* box-shadow: 0 20px 20px 0 rgb(254 69 81 / 30%); */
}
.check-handler {
  display: flex;
  margin-left: 0.2em;
  justify-content: center;
  align-items: center;
  width: 1.5em;
  height: 1.5em;
  min-width: 1.5em;
  max-width: 1.5em;
  min-height: 1.5em;
  max-height: 1.5em;
  border-radius: 50%;
  transition: all 0.5s ease;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  &-sm {
    display: flex;
    // margin-left: 0.2em;
    justify-content: center;
    align-items: center;
    width: 1rem;
    height: 1rem;
    min-width: 1rem;
    max-width: 1rem;
    min-height: 1rem;
    max-height: 1rem;
    border-radius: 50%;
    transition: all 0.5s ease;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  }
}
/* .check-handler:before {
  content: "\f556";
  color: white;
  font-size: 3em;
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
} */
/* input[type="checkbox"]:checked + .check-trail {
  background: #48E98A;
  box-shadow: 0 20px 20px 0 rgb(72 233 138 / 30%);
} */
.check-handler-active {
  margin-left: 50%;
  /* background: #1ABC9C; */
  transform: rotate(360deg);
}
/* input[type="checkbox"]:checked + .check-trail .check-handler::before {
  content: "\f5b8";
} */
</style>
